import { ICommunityBlogItem, ICommunityBlogResult } from 'Frontend/scripts/models/communityBlog.model'
import { FunctionComponent, useEffect, useMemo, useState } from 'react'
import useQueryParams from 'Frontend/hooks/useQueryParams'
import Paging from 'Features/Paging/paging'
import * as blogService from 'Frontend/scripts/services/communityBlog.service'
import CommunityBlogItem from './CommunityBlogItem'
import { Spinner } from 'react-bootstrap'

interface EpiserverPageProps {
  contentId: string
}

interface CommunityBlogListingProps extends EpiserverPageProps {}

const CommunityBlogListing: FunctionComponent<CommunityBlogListingProps> = ({ contentId }) => {
  const { getQueryParam } = useQueryParams()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [activePage, setActivePage] = useState<number>(
    getQueryParam('page') ? parseInt(getQueryParam('page') as string) : 1,
  )

  const [blogResult, setBlogResult] = useState<ICommunityBlogResult>()
  const { items, pageSize, totalItems } = blogResult ?? {
    items: [],
    pageIndex: 1,
    pageSize: 1,
    totalItems: 1,
  }

  const numberOfPages = useMemo(() => {
    return Math.ceil(totalItems / pageSize)
  }, [totalItems])

  const getBlogResult = () => {
    setIsLoading(true)
    blogService.getBlogPosts(activePage, contentId).then((result) => {
      setBlogResult(result)
      setIsLoading(false)
    })
  }

  useEffect(() => {
    if (contentId) getBlogResult()
  }, [activePage, contentId])

  return (
    <div className="blog-list" id="blogs">
      {isLoading ? (
        <div className="py-3 d-flex justify-content-center align-items-center">
          <Spinner animation="border" role="status" variant="primary" />
        </div>
      ) : (
        <>
          {items?.map((item: ICommunityBlogItem) => (
            <CommunityBlogItem blogItem={item} key={item.contentId} commentCollection={item.comments} />
          ))}
        </>
      )}
      {items.length > 0 && (
        <Paging
          noOfPages={numberOfPages}
          activePage={activePage || 1}
          callback={(pageIndex: number) => setActivePage(pageIndex)}
        />
      )}
    </div>
  )
}

export default CommunityBlogListing
